import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import PropTypes from 'prop-types';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import IconButton from '@material-ui/core/IconButton';
import {
  TableCell,
  TableRow,
  Typography,
} from '@material-ui/core';

import 'react-datepicker/dist/react-datepicker.css';

class EcommDataDateAndNameRow extends Component {
  render() {
    const {
      date,
      fetchNext,
      fetchPrevious,
      handleDatePickerChange,
      locationNames,
    } = this.props;

    return (
      <>
        <TableRow>
          <TableCell key="datepicker">
            <div className="datepicker">
              <IconButton
                className="left"
                color="secondary"
                onClick={fetchPrevious}
              >
                <ArrowBackIosIcon />
              </IconButton>
              <DatePicker
                selected={date}
                onChange={handleDatePickerChange}
              />
              <IconButton
                className="right"
                color="secondary"
                onClick={fetchNext}
              >
                <ArrowForwardIosIcon />
              </IconButton>
            </div>
          </TableCell>
          {locationNames.map(locationName => {
            return (
              <TableCell key={`date-row-${locationName}`} className="studioDataDate">
                <Typography className="studioDataDate">
                  {locationName}
                </Typography>
              </TableCell>
            );
          })}
        </TableRow>
      </>
    )
  }
}

EcommDataDateAndNameRow.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
  fetchNext: PropTypes.func.isRequired,
  fetchPrevious: PropTypes.func.isRequired,
  handleDatePickerChange: PropTypes.func.isRequired,
  locationNames: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default EcommDataDateAndNameRow;
